import { render, staticRenderFns } from "./PointSetting.vue?vue&type=template&id=d6d37dfc&scoped=true"
import script from "./PointSetting.vue?vue&type=script&lang=js"
export * from "./PointSetting.vue?vue&type=script&lang=js"
import style0 from "./PointSetting.vue?vue&type=style&index=0&id=d6d37dfc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d37dfc",
  null
  
)

export default component.exports